import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { useScreenWidth } from "Root/profile/components/SubscriptionPageV2/hooks";
import styles from "./styles.module.css";
function MobileAccordion(props) {
    const [isOpen, setIsOpen] = useState(props.open);
    const isMobile = useScreenWidth() < 999;
    const handleClick = () => {
        if (isMobile) {
            setIsOpen(!isOpen);
        }
    };
    return (_jsxs("div", { className: styles.accordiontab, children: [_jsx("button", { className: `${styles.header} ${isOpen ? styles.open : ""} ${props.hideDesctopTitle && styles.mobileonly}`, onClick: handleClick, type: "button", children: props.title }), _jsx("div", { className: `${styles.container}  ${isOpen ? styles.containeropen : ""}`, children: props.children })] }));
}
export default MobileAccordion;
